import { httpGet, httpPatch } from "../connection";

export async function getOrgInfo(requestOptions = {}) {
  return await httpGet(`/orginfo`, {}, requestOptions);
}

export async function updateOrgInfo(values) {
  return await httpPatch(`/orginfo`, values);
}
